import { FC } from 'react';
import { GiftCardBlockStoryblok } from 'storyblok-types';
import { Picture } from 'atoms/Picture';
import { H1 } from 'atoms/Typography';
import { getProductsByParentReferenceKeys } from 'commerce/scayle/product-management';
import { GiftCardTileContainer } from './GiftCardTile';
import { IGiftCardBlock } from './types';
import styles from './styles.module.css';

export const GiftCardBlock: FC<IGiftCardBlock> = ({
  heroDesktop,
  heroMobile,
  title,
  giftCardItems,
  products,
}) => {
  const isImageVisible = heroDesktop?.filename || heroMobile?.filename;
  const isBlockVisible = title || isImageVisible || products?.length;

  const giftCards = products?.map((card) => {
    const relevantItem = giftCardItems?.find(
      (item) => item.productId === card.referenceKey,
    );

    return {
      ...card,
      mainImage: relevantItem?.mainImage,
      availableAmountsImages: relevantItem?.availableAmountsImages,
    };
  });

  return !isBlockVisible ? null : (
    <div className={styles.root}>
      {isImageVisible && (
        <Picture
          srcDesktop={heroDesktop}
          srcMobile={heroMobile}
          className={styles.hero}
        />
      )}
      {title && <H1 className={styles.title}>{title}</H1>}
      {giftCards?.map((card) => (
        <GiftCardTileContainer key={card.referenceKey} product={card} />
      ))}
    </div>
  );
};

export const GiftCardBlockContainer: FC<{
  blok: GiftCardBlockStoryblok;
}> = async ({ blok }) => {
  const { heroDesktop, heroMobile, title, giftCardItems } = blok;
  const itemsIds = giftCardItems?.map((item) => item.productId) || [];

  const { response: products, error } =
    await getProductsByParentReferenceKeys(itemsIds);

  if (error) {
    console.error(error);
    return null;
  }

  return (
    <GiftCardBlock
      heroDesktop={heroDesktop}
      heroMobile={heroMobile}
      title={title}
      giftCardItems={giftCardItems}
      products={products}
    />
  );
};
